<div fxLayoutAlign="start center">
  <div fxFlex fxLayout="column" fxLayoutGap="8px">
    <strong>Locations</strong>
    <span class="text__small night-lighter">
      Create locations to allow guests to search for properties near key locations.
    </span>
  </div>
  <sbnb-button type="secondary" size="mini" (click)="addLocation()">Add location</sbnb-button>
</div>

<div
  style="padding: 12px 0"
  cdkDropList
  dragAndDropManagerRoot
  [cdkDropListData]="locations"
  (cdkDropListDropped)="onDragDrop$.next($event)">
  <ng-container *ngFor="let item of locations">
    <sbnb-direct-location-editor-item
      [level]="0"
      [item]="item"
      [invert]="invert"
      [onDrop]="onDragDrop$"
      (itemAdded)="addLocation($event)"
      (itemDeleted)="removeLocation($event)"
      (itemEdited)="editLocation($event)"></sbnb-direct-location-editor-item>
  </ng-container>
</div>
